import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  position: relative;
  padding: 17px 24px 24px;
`;
export const Label = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
  margin-top: 16px;
`;

export const FilterText = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 400;
`;
export const Tag = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 400;
  border-radius: 12px;
  background: ${beam.background.tag};
  color: ${beam.color.pureWhite};
  padding: 2px 10px 1px;
`;
export const FilterDiv = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 13px;
  & .MuiFormControlLabel-root {
    margin-right: 8px !important;
  }
`;
export const Header = styled.h1`
  color: ${beam.font.primary};
  font-size: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  align-items: center;
`;
export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-bottom: 16px;

  /* borders/default-border */
  border-top: 1px solid ${beam.border.back};
`;
export const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #e9edf1;
  background: #fff;
  color: #838a91;
  font-size: 16px;
  padding: 5px 12px;
  width: 100%;
`;

export const Block = styled.div`
  background: #fff;
  padding: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 200px;
  min-height: 200px;
  z-index: 11;
`;

interface IItem {
  active: boolean;
}

export const Item = styled.div<IItem>`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: ${({ active }) => (active ? '#F6F8FF' : '#fff')};
  cursor: pointer;
`;
interface IItemListText {
  active: boolean;
}

export const ItemListText = styled.div<IItemListText>`
  font-size: 14px;
  flex: 1;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const WindowButton = styled.div`
  cursor: pointer;
  height: 14px;
  display: flex;
  align-items: flex-end;
  user-select: none;
`;

export const WindowButtonImage = styled.img``;

export const Cancel = styled.button`
  color: #838a91;
  font-size: 14px;
  background: none;
  border: none;
`;

interface IConfirm {
  active: boolean;
}

export const Confirm = styled.button<IConfirm>`
  color: #1371fe;
  font-size: 14px;
  cursor: pointer;
  background: none;
  border: none;
  opacity: ${({ active }) => (active ? '1' : '0.3')};
`;

export const DateDiv = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 16px;
`;
